/**
 * 菜单配置
 * text 使用 i18n key，对应 /public/locales/{lang}/menu.json
 */

export const dashboardPagesMenu = {
  tagManagement: {
    id: 'tagManagement',
    text: 'Tag Management',
    path: '/tag-management',
    icon: 'Label',
    subMenu: null,
  },
  audienceManagement: {
    id: 'audienceManagement',
    text: 'Audience Management',
    path: '/audience-management',
    icon: 'Groups',
    subMenu: null,
  },
  audienceInsight: {
    id: 'audienceInsight',
    text: 'Analytics',
    path: '/audience-insight',
    icon: 'Insights',
    subMenu: null,
  },
};

// 子页面路由（不在菜单中显示）
export const subPagesMenu = {
  createAudience: {
    id: 'createAudience',
    text: 'Create Audience',
    path: '/presentation/audience-management/create',
    icon: 'AddCircle',
  },
  copyTag: {
    id: 'copyTag',
    text: 'Copy Tag',
    path: '/presentation/tag-management/copy',
    icon: 'ContentCopy',
  },
};

/** 认证相关页面路由（登录、404 等） */
export const authPagesMenu = {
  login: {
    id: 'login',
    text: 'Login',
    path: 'auth-pages/login',
    icon: 'Login',
  },
  page404: {
    id: 'Page404',
    text: '404 Page',
    path: 'auth-pages/404',
    icon: 'ReportGmailerrorred',
  },
};
